export type UnitDeviceCheck = {
	ownedCount: number;
	sharedCount: number;
};

type CheckUnitDevicesResponse = {
	isok: boolean;
	data?: { owned?: number; shared?: number };
	owned?: number;
	shared?: number;
};

function toCount(value: unknown): number {
	if (typeof value === 'number' && Number.isFinite(value)) {
		return value;
	}
	if (typeof value === 'string' && value.trim() !== '') {
		const n = Number(value);
		return Number.isFinite(n) ? n : 0;
	}
	return 0;
}

export function normalizeCheckResponse(res: CheckUnitDevicesResponse): UnitDeviceCheck {
	const nested =
		res.data !== undefined && res.data !== null && typeof res.data === 'object' ? res.data : null;
	const owned = nested?.owned ?? res.owned;
	const shared = nested?.shared ?? res.shared;
	return {
		ownedCount: toCount(owned),
		sharedCount: toCount(shared),
	};
}

/** Pick a unit id to switch to before deleting `targetUnitId` (must not delete while session is on target). */
export function getFallbackUnitIdForDelete(options: {
	targetUnitId: string;
	originalUnitId: string | null;
	availableUnitIds: string[];
}): string | null {
	const { targetUnitId, originalUnitId, availableUnitIds } = options;
	if (originalUnitId && originalUnitId !== targetUnitId && availableUnitIds.includes(originalUnitId)) {
		return originalUnitId;
	}
	return availableUnitIds.find((id) => id !== targetUnitId) ?? null;
}
